/**
* DevExpress HTML/JS Reporting (designer\controls\utils\_bindings.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { XRCheckBoxSurface } from '../xrCheckbox';
var svgAttrs = ko.bindingHandlers['svgAttrs'];
ko.bindingHandlers['svgAttrs'] = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        svgAttrs.update(element, valueAccessor, allBindingsAccessor, viewModel);
        if (viewModel instanceof XRCheckBoxSurface) {
            element.setAttribute('preserveAspectRatio', 'none');
        }
    }
};
